import { render, staticRenderFns } from "./employment-date-field.vue?vue&type=template&id=bda32cdc"
import script from "./employment-date-field.vue?vue&type=script&lang=js"
export * from "./employment-date-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports